import {
  UI_HIDE_NOTIFICATION,
  UI_SET_CURRENT_LOCALE,
  UI_SET_CURRENT_PAGE,
  UI_SET_SIDEBAR_COLLAPSED,
  UI_SHOW_NOTIFICATION,
  UI_SET_MODAL_OPEN,
  UI_SET_LOADING,
} from "./uiTypes";

const initialState = {
  currentPage: "templates",
  sidebarCollapsed: false,
  currentLocale: "en",
  notifications: [],
  modals: {},
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case UI_SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case UI_SET_SIDEBAR_COLLAPSED:
      return {
        ...state,
        sidebarCollapsed: action.payload,
      };
    case UI_SET_MODAL_OPEN:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.payload.modalType]: {
            open: action.payload.open,
            data: action.payload.data,
          },
        },
      };
    case UI_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case UI_SET_CURRENT_LOCALE:
      return {
        ...state,
        currentLocale: action.payload,
      };

    case UI_SHOW_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };

    case UI_HIDE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => n.id !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default uiReducer;
